import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import './ContactPage.css';

export default function ContactPage({ onBack }) {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);
  const base = process.env.REACT_APP_API_BASE;  

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await fetch(`${base}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      if (!res.ok) throw new Error(await res.text());
      setStatus('sent');
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      console.error(err);
      setStatus('error');
    }
  };

  return (
    <div className="contact-modern-home">
      <Helmet><title>Contact | Insight Data LLC</title></Helmet>
      <section className="contact-modern-header">
        <button onClick={onBack} className="back-link" style={{ marginBottom: '1rem' }}>
          Back
        </button>
      </section>
      <section className="contact-modern-title-section">
        <h1 className="contact-modern-title">Contact Me</h1>
      </section>
      <div className="contact-modern-card">
        {status === 'sent' && <div className="contact-modern-status success">Thanks! I’ll be in touch soon.</div>}
        {status === 'error' && <div className="contact-modern-status error">Oops—something went wrong.</div>}
        <form className="contact-modern-form" onSubmit={handleSubmit}>
          <label className="contact-modern-label">
            Name
            <input
              type="text"
              name="name"
              value={form.name}
              onChange={handleChange}
              required
              className="contact-modern-input"
            />
          </label>
          <label className="contact-modern-label">
            Email
            <input
              type="email"
              name="email"
              value={form.email}
              onChange={handleChange}
              required
              className="contact-modern-input"
            />
          </label>
          <label className="contact-modern-label">
            Message
            <textarea
              name="message"
              value={form.message}
              onChange={handleChange}
              required
              rows={6}
              className="contact-modern-textarea"
            />
          </label>
          <button
            type="submit"
            disabled={status === 'sending'}
            className="contact-modern-submit"
          >
            {status === 'sending' ? 'Sending…' : 'Send Message'}
          </button>
        </form>
      </div>
    </div>
  );
}
